import { render, staticRenderFns } from "./ProjectContentDisplay.vue?vue&type=template&id=227b2440&scoped=true"
import script from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
export * from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProjectContentDisplay.vue?vue&type=style&index=0&id=227b2440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b2440",
  null
  
)

export default component.exports